var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var _a, _b;
import { getDriveActionLabelKey } from '@web/components/Apps/DriveAdvancedSearch/utils';
import { DRIVE_DAILY_TIMELINE_COLORS_CONFIG, DRIVE_DAILY_TIMELINE_LEGEND_KEYS } from '@web/config';
import { DocumentSharingStatusEnum, DriveEventActionEnum } from '@workalizer/shared';
import { getDriveSharingStatus } from '@workalizer/shared/utils/driveEventSharing';
var ACTION_LEGEND_KEYS = (_a = {},
    _a[DriveEventActionEnum.DOCUMENT_CREATE] = 'created',
    _a[DriveEventActionEnum.DOCUMENT_EDIT] = 'edits',
    _a[DriveEventActionEnum.DOCUMENT_UPLOAD] = 'upload',
    _a[DriveEventActionEnum.DOCUMENT_VIEW] = 'views',
    _a[DriveEventActionEnum.DOCUMENT_PRINT] = 'prints',
    _a[DriveEventActionEnum.DOCUMENT_DOWNLOAD] = 'downloads',
    _a[DriveEventActionEnum.DOCUMENT_CREATE_COMMENT] = 'commentsPosted',
    _a[DriveEventActionEnum.DOCUMENT_EDIT_COMMENT] = 'commentsPosted',
    _a[DriveEventActionEnum.DOCUMENT_CREATE_SUGGESTION] = 'suggestionsPosted',
    _a[DriveEventActionEnum.DOCUMENT_ACCEPT_SUGGESTION] = 'suggestionsResolved',
    _a[DriveEventActionEnum.DOCUMENT_REJECT_SUGGESTION] = 'suggestionsResolved',
    _a[DriveEventActionEnum.DOCUMENT_APPROVAL_REQUESTED] = 'approvalRequested',
    _a);
var SHARING_STATUS_LEGEND_KEYS = (_b = {},
    _b[DocumentSharingStatusEnum.INTERNAL] = 'sharedInternally',
    _b[DocumentSharingStatusEnum.EXTERNAL] = 'sharedExternally',
    _b[DocumentSharingStatusEnum.PUBLIC_LINK] = 'sharedPublicly',
    _b);
var LEGEND_LABEL_KEYS = {
    created: 'app.driveAdvancedSearch.filters.actionTypes.create',
    edits: 'driveItemDetails.peopleActivityTable.edits',
    upload: 'app.driveAdvancedSearch.filters.actionTypes.upload',
    views: 'driveItemDetails.peopleActivityTable.views',
    prints: 'driveItemDetails.peopleActivityTable.prints',
    downloads: 'driveItemDetails.peopleActivityTable.downloads',
    commentsPosted: 'driveItemDetails.peopleActivityTable.commentsPosted',
    suggestionsPosted: 'driveItemDetails.peopleActivityTable.suggestionsPosted',
    suggestionsResolved: 'driveItemDetails.peopleActivityTable.suggestionsResolved',
    approvalRequested: 'app.driveAdvancedSearch.filters.actionTypes.approvalRequested',
    sharedInternally: 'driveItemDetails.peopleActivityTable.sharedInternally',
    sharedExternally: 'driveItemDetails.peopleActivityTable.sharedExternally',
    sharedPublicly: 'driveItemDetails.peopleActivityTable.sharedPublicly'
};
export var getDriveDailyTimelineLegendKey = function (action, subAction) {
    if (!action) {
        return null;
    }
    var actionLegendKey = ACTION_LEGEND_KEYS[action];
    if (actionLegendKey) {
        return actionLegendKey;
    }
    var sharingStatus = getDriveSharingStatus(action, subAction);
    return sharingStatus ? SHARING_STATUS_LEGEND_KEYS[sharingStatus] : null;
};
export var isDriveDailyTimelineLegendEvent = function (action, subAction) { return getDriveDailyTimelineLegendKey(action, subAction) !== null; };
export var getDriveDailyTimelineLegendLabelKey = function (legendKey) { return LEGEND_LABEL_KEYS[legendKey]; };
export var getDriveTimelineLegendItems = function (t) {
    return DRIVE_DAILY_TIMELINE_LEGEND_KEYS.map(function (key) { return ({
        key: key,
        label: t(getDriveDailyTimelineLegendLabelKey(key))
    }); });
};
export var getDriveTimelineSegmentColors = function (item) {
    var legendKey = getDriveDailyTimelineLegendKey(item.action, item.subAction);
    return legendKey ? DRIVE_DAILY_TIMELINE_COLORS_CONFIG[legendKey] : undefined;
};
export var getDriveTimelineItemUserLabel = function (item) { var _a, _b, _c, _d; return ((_b = (_a = item.users) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.name) || ((_d = (_c = item.users) === null || _c === void 0 ? void 0 : _c[0]) === null || _d === void 0 ? void 0 : _d.email) || ''; };
export var getDriveTimelineItemActionLabel = function (item, t) {
    if (!item.action) {
        return item.title;
    }
    return t(getDriveActionLabelKey(item.action, item.subAction));
};
export var mapDocumentTimelineItems = function (items, t) {
    return items.map(function (item) {
        var mappedItem = __assign(__assign({}, item), { startDate: new Date(item.startDate), endDate: item.endDate ? new Date(item.endDate) : null });
        return __assign(__assign({}, mappedItem), { title: item.action
                ? "".concat(getDriveTimelineItemActionLabel(mappedItem, t), " \u00B7 ").concat(getDriveTimelineItemUserLabel(mappedItem))
                : item.title });
    });
};
